export default __webpack_public_path__ + "static/media/icon_right_simple_black.33acdc03.svg";